import { Getter } from 'vuex'
import { RootState } from '@/store/types'
import { ProjectID } from '@/types/platform'

const getProjectId: Getter<RootState, RootState> = (state: RootState) => {
  return ProjectID[state.platform]
}

export default getProjectId
